export const PRICE_TYPE_MAP = {
  FUTURE: 'Future',
  FUTURE_BASE: 'Future Base',
  FUTURE_PEAK: 'Future Peak',
  DAY_AHEAD: 'Day Ahead',
  INTRADAY: 'Intraday',
  SPOT: 'Spot',
  AUCTION: 'Auction',
  HPFC: 'HPFC',
  MFC: 'MFC',
  IMBALANCE: 'Imbalance',
  FORECAST: 'Forecast',
  FREIGHT_RATE: 'Freight Rate',
  'unknown price type': 'Unknown Price Type',
};
export const PRODUCT_MAP = {
  CAL: 'Cal',
  SEASON: 'Season',
  QUARTER: 'Quarter',
  MONTH: 'Month',
  WEEK: 'Week',
  WEEKEND: 'Weekend',
  DAY: 'Day',
  BOM: 'Balance Of Month',
  BOW: 'Balance Of Week',
  SPOT: 'Spot',
  INTRADAY_CONTINUOUS: 'Intraday Continuous',
  INTRADAY_AUCTION: 'Intraday Auction',
  DAY_AHEAD_CONTINUOUS: 'Day-Ahead Continuous',
  DAY_AHEAD_AUCTION: 'Day-Ahead Auction',
  HPFC: 'HPFC',
  MFC: 'MFC',
  IMBALANCE: 'Imbalance',
  FORECAST: 'Forecast',
  'unknown product': 'Unknown Product',
};
